import { useState } from 'react'

import { Cell } from '../../../../components/ReusableComponents/Table'
import styles from './EventsCell.module.scss'
import { ReactComponent as BounceIcon } from './svgs/bounce.svg'
import { ReactComponent as ClickedIcon } from './svgs/clicked.svg'
import { ReactComponent as DeliveredIcon } from './svgs/delivered.svg'
import { ReactComponent as OpenedIcon } from './svgs/opened.svg'
import { ReactComponent as SpamIcon } from './svgs/spam.svg'
import CustomTooltip from './Tooltip/index'

export const EventsCell = ({ events, ...props }) => {
  const eventsByType = {
    spam: events.filter(e => e.kind === 'Spam'),
    bounce: events.filter(e => e.kind === 'Bounce'),
    delivered: events.filter(e => e.kind === 'Delivered'),
    opened: events.filter(e => e.kind === 'Opened'),
    clicked: events.filter(e => e.kind === 'Clicked')
  }

  const Icon = ({ type, activeClass, Icon }) => {
    const isActive = eventsByType[type].length > 0
    const [isHovering, setHovering] = useState()

    return (
      <div
        className={styles.iconHolder}
        onMouseOver={() => isActive && setHovering(true)}
        onMouseLeave={() => isActive && setHovering(false)}
      >
        {eventsByType[type].length > 1 && (
          <div className={styles.badge}>{eventsByType[type].length}</div>
        )}
        {isHovering && <CustomTooltip eventList={eventsByType[type]} />}
        <Icon className={isActive > 0 ? activeClass : ''} />
      </div>
    )
  }

  return (
    <Cell className={styles.cell} {...props}>
      <Icon type="bounce" Icon={BounceIcon} activeClass={styles.badActive} />
      <Icon type="spam" Icon={SpamIcon} activeClass={styles.badActive} />
      <Icon type="delivered" Icon={DeliveredIcon} activeClass={styles.goodActive} />
      <Icon type="opened" Icon={OpenedIcon} activeClass={styles.goodActive} />
      <Icon type="clicked" Icon={ClickedIcon} activeClass={styles.goodActive} />
    </Cell>
  )
}
